$(function () {
    var $corporateHeader = $('[data-corporate-header]');
    if ($corporateHeader.length > 0) {
        var background = $corporateHeader.find('input[type=hidden]').val();
        if (background !== '') {
            var header = $corporateHeader.closest('.main--header');
            header.attr('style', 'background-image: url(' + background + '); background-size: cover; background-position: bottom;');
        }
    }
});